module.exports = __webpack_public_path__ + "static/media/file-invoice.1680f3c3.svg";